<template>
  <BaseOption>
    <template v-slot:body>
      <div class="main-card mb-3 card design-options">
        <div class="card-header">
          Designs
          <div class="btn-actions-pane-right">
            <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="position-relative form-group col-12">
              <label class="col-12 mb-0 p-0">Flags</label>
              <ul class="flags">
                <li v-for="(object, index) in data.flags" :key="index" class="radio-container">
                  <input type="checkbox" name="design[flags]" :value="index" :checked="values.flags.indexOf(index) != -1" @change="handleChangeFlag" />
                  <span :class="`checkmark choose-flag ${index}`"></span>
                </li>
              </ul>
            </div>
            <div v-show="data.detail.open_blueprint" class="position-relative form-group col-12 detail-open-blueprint">
              <label class="col-12 mb-0 p-0">Open Blueprint</label>
              <div class="btn-group-sm nav btn-group mt-2 d-inline-block">
                <div v-for="(object, index) in data.detail.open_blueprint" :key="index" class="radio-container btn-shadow btn btn-primary show p-0">
                  <input type="radio" name="design[detail][open_blueprint]" :value="index" :checked="values.detail.open_blueprint == index" @change="store.commit('values.detail.open_blueprint', index)" />
                  <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
                </div>
              </div>
            </div>
            <div v-show="data.tablelist.more" class="position-relative form-group col-12 tablelist-more">
              <label class="col-12 mb-0 p-0">More in tablelist</label>
              <div class="btn-group-sm nav btn-group mt-2 d-inline-block">
                <div v-for="(object, index) in data.tablelist.more" :key="index" class="checkbox-container btn-shadow btn btn-primary show p-0">
                  <input type="checkbox" name="design[tablelist][more][]" :value="index" :checked="Object.values(values.tablelist.more).indexOf(index) != -1" @click="handleChangeTablistMore" />
                  <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseOption>
</template>

<script>
import Event from '@/helper/event.js'
import BaseOption from '@/views/Option/BaseOption.vue'
export default {
  mixins: [Event],
  components: {
    BaseOption
  },
  computed: {
    storeId() {
      return 'main'
    },
    indexUri() {
      return 'design/option'
    },
    submitUri() {
      return 'design/option/update'
    },
    data() {
      return this.store.getter('data', {
        flags: {},
        detail: {},
        tablelist: {
          more: {}
        }
      })
    },
    values() {
      return this.store.getter('values', {})
    }
  },
  methods: {
    setUpData({ status, data }) {
      if (status != 'success') return
      data.values = Object.assign(
        {
          flags: ['empty', 'yellow', 'orange', 'red', 'green', 'blue'],
          detail: {
            open_blueprint: 'link'
          },
          tablelist: {
            more: ['refer_order', 'blueprint']
          }
        },
        data.values
      )
      this.store.commit('', data)
    },
    handleChangeFlag(e) {
      let values = Object.values(this.values.flags || [])
      if (e.target.checked == true) {
        values.push(e.target.value)
      } else if (values.indexOf(e.target.value) !== -1) {
        values.splice(values.indexOf(e.target.value), 1)
      }
      this.store.commit('values.flags', values)
    },
    handleChangeTablistMore(e) {
      let values = Object.values(this.values.tablelist.more || [])
      if (values.indexOf(e.currentTarget.value) != -1) {
        values.splice(values.indexOf(e.target.value), 1)
      } else {
        values.push(e.currentTarget.value)
      }
      this.store.commit('values.tablelist.more', values)
    },
    handleClickSave() {
      this.submitForm(this.store.getter('values', {}))
    }
  }
}
</script>
